import React from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  getStatusHue,
  normalizeStatus,
  statusLabels,
  tagStyle,
} from '../theme/statusTokens';

export interface StatusPillProps {
  status?: string;
  /** Override the label (e.g. "destroyed" / "destroy failed"). */
  label?: string;
  /** Override the hue (paired with a custom label). */
  hue?: string;
  size?: 'small' | 'medium';
}

/** Notion-tag style status pill: faint tinted background, readable text. */
const StatusPill: React.FC<StatusPillProps> = ({ status, label, hue, size = 'small' }) => {
  const theme = useTheme();
  const resolvedHue = hue ?? getStatusHue(status);
  const style = tagStyle(resolvedHue, theme.palette.mode);
  return (
    <Chip
      label={label ?? statusLabels[normalizeStatus(status)]}
      size={size}
      sx={{
        backgroundColor: style.bg,
        color: style.text,
        border: `1px solid ${style.border}`,
        fontWeight: 600,
        fontSize: '0.72rem',
        height: 22,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
};

export default StatusPill;
